export default "__VITE_ASSET__4217e669__"